module.exports = __webpack_public_path__ + "images/category_lp/alcohol/new/store_images/1_02af28d899a69239ee6efa1b080cb47a.png";